export default __webpack_public_path__ + "static/bluecrossBlueshield-f8630ed3294e66a964214c3d3ebad0b9.svg";